import { createContext } from 'react'

export interface PanelToggleOptions {
  /** Open beside the other panel instead of replacing it (Ctrl/Cmd+click). */
  alongside?: boolean
}

export interface PanelStackValue {
  chatSession: { key: number; threadId?: string; draft: string } | null
  isChatProtected: boolean
  setChatProtected: (protectedChat: boolean) => void
  /** Moves a saved conversation and its draft into the panel without replacing a busy chat or draft. */
  dockChat: (chat: { threadId?: string; draft: string }) => boolean
  isChatOpen: boolean
  /** True while chat is open or hidden behind a replacing panel; keeps its state alive. */
  isChatMounted: boolean
  toggleChat: (options?: PanelToggleOptions) => void
  closeChat: () => void
  isSupportOpen: boolean
  isSupportMounted: boolean
  toggleSupport: (options?: PanelToggleOptions) => void
  closeSupport: () => void
}

export const PanelStackContext = createContext<PanelStackValue | null>(null)
